module.exports = __webpack_public_path__ + "48aa7ad98beedc63d82925f45fd8e72c.woff2";